import { Menu } from '@headlessui/react';
import { FC } from 'react';
import { MdPerson } from 'react-icons/md';

import clsx from 'clsx';
import { FaSignOutAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';

export const Account: FC = () => {
  return (
    <Menu>
      <Menu.Button as="button" className="flex items-center justify-center gap-2">
        <div className="relative">
          <div className="bg-primary-100 flex h-10 w-10 items-center justify-center rounded-full">
            <MdPerson className="text-primary-700 h-6 w-6" />
          </div>
          <Menu.Items className="absolute z-50 right-0 mt-2 min-w-fit divide-y divide-gray-100 rounded-md border border-gray-200 bg-white shadow-lg outline-none">
            <div>
              <Menu.Item>
                {({ active }) => (
                  <Link
                    to="/auth/signout"
                    className={clsx(
                      active && 'bg-gray-50',
                      'text-primary-std flex items-center gap-3 whitespace-nowrap px-4 py-2 text-left text-sm'
                    )}
                  >
                    <FaSignOutAlt className="text-secondary-std" />
                    <span>Sign out</span>
                  </Link>
                )}
              </Menu.Item>
            </div>
          </Menu.Items>
        </div>
      </Menu.Button>
    </Menu>
  );
};
